<span
  *ngIf="tableCountsInfo$ | ngrxPush as tci"
  class="table-counts"
  nz-typography
  nzType="secondary">
  {{ tci.edgeCount | number }} of {{ tci.filteredCount | number }} displayed
</span>
